import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import {
  selectWeatherMeasuresPlottedSeries,
  selectWeatherPlottedMeasure,
} from 'redux/restResources/detail/weather/selectors';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { WeatherMeasurePlot as Component } from './WeatherMeasurePlot.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

type IInjectedProps = IStateProps & IDispatchProps;
export type IProps = IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  const routeWeather = selectRouteResource(rrc.weather)(rootState);

  return {
    routeWeather,
    plottedSeries: selectWeatherMeasuresPlottedSeries(rootState),
    plottedMeasure: selectWeatherPlottedMeasure(rootState),
  };
};

const mapDispatchToProps = {
  //
};

export const WeatherMeasurePlot = connect(mapStateToProps, mapDispatchToProps)(Component);
